let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page001_game0/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page001_game0/audio/s1_1.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 115,
        x: 256,
      },
      unit: 'px',
    },
    {
      src: 'games/page001_game0/audio/s1_2.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 115,
        x: 1010,
      },
      unit: 'px',
    },
    {
      src: 'games/page001_game0/audio/s1_3.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 584,
        x: 256,
      },
      unit: 'px',
    },
    {
      src: 'games/page001_game0/audio/s1_4.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 584,
        x: 1010,
      },
      unit: 'px',
    },
    {
      src: 'games/page001_game0/audio/Track_8_Story_1_Hello Lisa_.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: -17,
        x: 835,
      },
      unit: 'px',
    },
  ],
};

export default elements;
